import { MARKET, TMarket } from '@/common/constants/markets';
import {
  IInsurancePolicy,
  InsuranceFamilyPayment,
  TMemberSimulation,
} from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { t } from 'i18next';

export function buildDescription(policy: IInsurancePolicy, slug: TMarket) {
  const paymentType = getInsuranceFamilyPaymentType(policy);
  const marketPrefix = slug === MARKET.ES ? '.es' : '';

  let fullDescription = policy.upgradable
    ? t(
        `dashboard.insurance_detail${marketPrefix}.simulate_family.description.${paymentType}.upgradable`
      )
    : t(
        `dashboard.insurance_detail${marketPrefix}.simulate_family.description.${paymentType}`
      );

  if (policy.gracePeriod) {
    fullDescription += ` ${t(
      'dashboard.insurance_detail.simulate_family.description.grace_period'
    )}`;
  }

  return fullDescription;
}

export const getInsuranceFamilyPaymentType = (
  policy: IInsurancePolicy
): InsuranceFamilyPayment => {
  if (
    policy.settings.payment.child?.company === 1 &&
    policy.settings.payment.spouse?.company === 1
  ) {
    return 'pay_none';
  }
  if (policy.settings.payment.child?.company === 1) {
    return 'pay_spouse';
  }
  if (policy.settings.payment.spouse?.company === 1) {
    return 'pay_child';
  }
  return 'pay_all';
};

export const addEditableFieldsToPersons = (
  persons: TMemberSimulation[]
): TMemberSimulation[] => {
  return persons.map((person) => {
    const editableFields: string[] = [];

    if (!person.shortName) editableFields.push('shortName');
    if (!person.taxNumber?.value) editableFields.push('taxId');
    if (!person.gender) editableFields.push('gender');

    return {
      ...person,
      editableFields,
    };
  });
};
